import { Controller } from '@stimulus/core';
import autosize from 'autosize';
export default class extends Controller {
    connect() {
        autosize(this.element.querySelectorAll('textarea'));
    }
}
